<script setup>
  import { ref, computed, onMounted, watchEffect } from "vue";
  import { useMapStore } from "@/stores/MapStore";
  import { useForecastModelStore } from "@/stores/ForecastModelStore";  
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import { useDateHelper } from "@/composables/useDateHelper";
  import Popup from "@/components/controls/Popup.vue";

  const props = defineProps({
    modelInfo: {
      type: Object,
      required: true
    }
  });  

  const mapStore = useMapStore();
  const forecastModelStore = useForecastModelStore();
  const dateHelper = useDateHelper();
  const isDesktop = useMediaQuery('(min-width: 840px)');

  const selected = ref('');

  const modelRunOptions = computed(() => {
    return forecastModelStore.selectedModelRuns.map((run) => {
      return {
        id: run.model_run_id,
        name: run.model_run_name,
        date: dateHelper.modelRunTimeFormatted({
          timestamp: run.model_run_time_utc, 
          utcOffset: '+0000',
          year: isDesktop.value,
        })
      }
    });
  });

  const modelRunCondensedDate = computed(() => {
    return dateHelper.modelRunTimeFormatted({
      timestamp: forecastModelStore.selectedModelRunTime, 
      utcOffset: mapStore.state.geoInfo.local_utc_offset,
      condensed: true
    })
  });

  function handleModelRunChange(e, modelRunId) {
    forecastModelStore.setSelectedModelRun(modelRunId);
    mapStore.state.fxModelRun = forecastModelStore.selectedModelRunTime;
    mapStore.customizedMapUpdate('fx'); 
  }  
  
  onMounted(() => {
    selected.value = forecastModelStore.selectedModelRuns[0].model_run_id;
  });

  watchEffect(() => {
    selected.value = forecastModelStore.selectedModelRuns[0].model_run_id;
  });

</script>
<template>
  <Popup
    :id="props.modelInfo.id"
    :teleport="true"
  >
    <template #button-content>
      <div class="jwx-source-selector__popup-text-button">
        <div class="jwx-source-selector__model-run-condensed">
          <span class="jwx-source-selector__model-run-name">{{ forecastModelStore.selectedModelRunName }}</span> {{ modelRunCondensedDate }}
        </div>
      </div>
    </template>
    <template #menu-content>
      <div class="jwx-popup-menu">
        <div class="jwx-action-menu">
          <ul class="jwx-action-menu__list">
            <li 
            v-for="modelRun in modelRunOptions"
            :key="modelRun.id"
            class="jwx-action-menu__action"
            >
            <button
              @click.prevent="handleModelRunChange($event, modelRun.id)"
              class="jwx-action-menu__action-button"
              :data-selected="modelRun.id === forecastModelStore.selectedModelRun.model_run_id"
            >
              <div class="jwx-source-selector__model-run jwx-action-menu__action-label"><span class="jwx-source-selector__model-run-name">{{ modelRun.name }}</span> <span class="jwx-source-selector__model-run-date">{{ modelRun.date }}</span></div>
            </button>
            </li>
          </ul>
        </div>           
      </div>
    </template>
  </Popup>
</template>